<div class="theme-override grow" [ngClass]="Card.Theme" *ngFor="let Card of Cards$ | async; let i = index">
    <a mat-flat-button class="button" [routerLink]="Card.Route" [disabled]="Card.Disabled" color="primary-lighter">
        <div class="button-content">
            <fa-icon class="icon" size="2x" [icon]="Card.Image"></fa-icon>
            <span class="label">{{ Card.Title }}</span>
        </div>
    </a>
</div>
